import React, { useState } from "react";
import {
  Dropdown,
  TextField,
  DatePicker,
  PrimaryButton,
  MessageBar,
  MessageBarType,
  Stack,
} from "@fluentui/react";

const DWRHelpForm = () => {
  const [formData, setFormData] = useState({
    category: "Meeting Logistics",
    subject: "",
    meetingName: "",
    meetingDate: null,
    requestDetails: "",
    alias: "",
    error: "",
  });

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handleSubmit = () => {
    const { subject, meetingName, meetingDate, requestDetails } = formData;
    if (!subject || !meetingName || !meetingDate || !requestDetails) {
      setFormData({ ...formData, error: "Please fill all the required fields to proceed." });
      return;
    }
    alert("Form submitted successfully!");
  };

  return (
    <div style={{ width: '100vh', height: '100vh', padding: '20px', boxSizing: 'border-box' }}>
      <Stack tokens={{ childrenGap: 10 }} styles={{ root: { width: '100%', height: '100%' } }}>
        
        {formData.error && (
          <MessageBar messageBarType={MessageBarType.error} onDismiss={() => handleChange("error", "")}
            styles={{ root: { width: '100%' } }}>
            {formData.error}
          </MessageBar>
        )}

        <Dropdown
          label="Category"
          options={[{ key: "Meeting Logistics", text: "Meeting Logistics" }]}
          selectedKey={formData.category}
          styles={{ root: { width: '100%' } }}
        />

        <TextField
          label="Subject"
          required
          value={formData.subject}
          onChange={(e, value) => handleChange("subject", value)}
          styles={{ root: { width: '100%' } }}
        />

        <Stack horizontal tokens={{ childrenGap: 10 }} styles={{ root: { width: '100%' } }}>
          <Dropdown
            label="Meeting Name"
            required
            options={[{ key: "Meeting 1", text: "Meeting 1" }, { key: "Meeting 2", text: "Meeting 2" }]}
            onChange={(e, option) => handleChange("meetingName", option.key)}
            styles={{ root: { width: '50%' } }}
          />

          <DatePicker
            label="Meeting Date"
            placeholder="Select a date"
            value={formData.meetingDate}
            onSelectDate={(date) => handleChange("meetingDate", date)}
            isRequired
            styles={{ root: { width: '50%' } }}
          />
        </Stack>

        <TextField
          label="Request / Query Details"
          required
          multiline
          value={formData.requestDetails}
          onChange={(e, value) => handleChange("requestDetails", value)}
          rows={4}
          styles={{ root: { width: '100%' } }}
        />

        <TextField
          label="Alias of secondary/backup contacts"
          value={formData.alias}
          onChange={(e, value) => handleChange("alias", value)}
          placeholder="Separate each user/group with a comma or semicolon"
          styles={{ root: { width: '50%' } }}
        />

        <Stack horizontal horizontalAlign="end" styles={{ root: { width: '100%' } }}>
          <PrimaryButton
            text="Submit"
            onClick={handleSubmit}
            styles={{ root: { width: 'auto', padding: '5px 20px' } }}
          />
        </Stack>
      </Stack>
    </div>
  );
};

export default DWRHelpForm;
